import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import React from 'react'
import { CMBCEnhancedPhoneInput } from 'src/clinic/components/ClinicManageBookingsPage/ClinicManageBookingComponents'
import { GRID_CONFIG } from '../utils/patientFormConfig'
import { ArrayFormField } from './FormField'

export const PatientAlternativeMobiles = ({
  alternativeMobiles = [],
  onAdd,
  onUpdate,
  onRemove,
  editMode = true,
  validationHook,
}) => {
  const renderAlternativeMobile = (mobile, index, { onUpdate, onRemove, disabled }) => {
    const validation = validationHook?.getAlternativeMobileValidation(index)

    return (
      <div key={index} className="d-flex align-items-center gap-2 mb-2">
        <div style={{ flex: 1 }}>
          <div className="d-flex flex-column">
            <CMBCEnhancedPhoneInput
              disabled={disabled}
              placeholder="Alternative Mobile Number"
              value={mobile || ''}
              onChange={(value) => {
                if (!disabled) {
                  onUpdate(index, value)
                }
              }}
            />
            {validation?.showError && (
              <small className="text-danger">{validation.errorMessage}</small>
            )}
          </div>
        </div>

        <DeleteOutlineIcon
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1
          }}
          onClick={() => {
            if (!disabled) {
              onRemove(index)
            }
          }}
        />
      </div>
    )
  }

  return (
    <ArrayFormField
      label="Alternative Mobile Numbers"
      items={alternativeMobiles}
      onAdd={editMode ? onAdd : undefined}
      onRemove={editMode ? onRemove : undefined}
      onUpdate={editMode ? onUpdate : undefined}
      renderItem={renderAlternativeMobile}
      disabled={!editMode}
      gridConfig={GRID_CONFIG}
      AddIcon={AddCircleOutlineIcon}
    />
  )
}

export default PatientAlternativeMobiles